import { z } from 'zod';

export const stepProgressSchema = z.object({
  done: z.number(),
  total: z.number(),
});

export type IStepProgress = z.infer<typeof stepProgressSchema>;
